export function serializeQueryParams(params) {
  let keys = Object.keys(params);
  return keys
    .map((key) => {
      let urlKey = encodeURIComponent(key);
      let value = encodeURIComponent(params[key]);
      return `${urlKey}=${value}`;
    })
    .join('&');
}
